<template>
  <div class="home-div">
    <SideBar style="z-index: 9999" />
    <div class="content">
      <div class="left">
        <div v-if="loading" class="info-tip font-color-1">
          正在加载中，请稍后~
        </div>
        <div v-else-if="!travelDetail" class="info-tip font-color-1">
          游记不存在或已被删除
        </div>
        <div v-else class="info mbl-no-hover slide-in-left">
          <!-- 第一行：province | city | travelTitle -->
          <div class="title-row font-color-1">
            <span class="travel-title">{{ travelDetail.province }} | {{ travelDetail.city }} | {{ travelDetail.travelTitle }}</span>
          </div>

          <!-- 正文：markdown渲染 -->
          <mavon-editor 
            v-model="travelDetail.travelDesc" 
            :subfield="false" 
            :defaultOpen="'preview'" 
            :toolbarsFlag="false"
            :xssOptions="false"
            :editable="false" 
            style="height: auto !important; min-height: 400px;"
            :previewBackground="'background-color: rgba(255, 255, 255, 0) !important'" 
            :ishljs="true"
            :imageClick="handleMavonImgClick" 
            class="md-editor font-color-1" 
          />

          <!-- 末尾右下角显示时间 -->
          <div class="travel-time-footer">
            {{ travelDetail.travelTime }}
          </div>
        </div>
      </div>
    </div>
    <BottomTip style="padding-top: 50px;" />

    <!-- 全屏图片预览模态框（复制过来） -->
    <div v-if="isFullscreen" class="fullscreen-overlay" @click.self="closeFullscreen">
      <div class="fullscreen-content">
        <img :src="currentFullscreenImage" class="fullscreen-image" @click="closeFullscreen" />
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/menu/SideBar.vue';
import BottomTip from '@/components/menu/BottomTip.vue';
import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import { Message } from 'element-ui';
import { getTravelDetail } from '@/api/travels.js';

export default {
  name: 'TravelDetail',
  components: {
    SideBar,
    BottomTip,
    mavonEditor
  },
  data() {
    return {
      travelDetail: null,
      loading: true,
      // 新增全屏预览变量
      isFullscreen: false,
      currentFullscreenImage: ""
    }
  },
  async mounted() {
    const id = this.$route.query.id;
    if (!id) {
      Message.error('缺少游记ID参数');
      this.loading = false;
      return;
    }
    await this.loadTravelDetail(id);
  },
  methods: {
    async loadTravelDetail(id) {
      this.loading = true;
      try {
        const response = await getTravelDetail({ id: id });
        if (response && response.code === 200 && response.data) {
          this.travelDetail = response.data;
        } else {
          Message.error(response?.msg || '获取游记详情失败');
        }
      } catch (error) {
        console.error('获取游记详情失败:', error);
        Message.error('网络错误，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    // 图片点击回调（和你LifeDetail保持一致）
    handleMavonImgClick(imgDom) {
      this.currentFullscreenImage = imgDom.src;
      this.isFullscreen = true;
      document.body.style.overflow = "hidden";
    },
    closeFullscreen() {
      this.isFullscreen = false;
      document.body.style.overflow = "";
    }
  }
}
</script>

<style scoped>
/* 动画样式 */
.slide-in-left {
  opacity: 0;
  margin-left: -50px;
  animation: slideInLeftSoft 0.8s ease-out 0.6s forwards;
}

@keyframes slideInLeftSoft {
  to {
    opacity: 1;
    margin-left: 0;
  }
}

/* 基础布局 */
.home-div {
  width: 100%;
  min-height: 100vh;
  padding-top: 60px;
  overflow: hidden;
}

.content {
  max-width: 100%;
  padding-left: 10%;
  padding-right: 10%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.left {
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  border-radius: 8px;
}

.info {
  width: 100%;
  margin-bottom: 20px;
  border-radius: 10px;
  box-shadow:
    7px 7px 10px rgba(0, 0, 0, .9),
    -5px -5px 10px rgba(239, 235, 235, 0.3);
}

.info-tip {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

/* 第一行样式：省份|城市 + 标题 */
.title-row {
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 20px;
}

.province-city {
  font-size: 14px;
  color: #94a3b8;
  letter-spacing: 1px;
  margin-bottom: 12px;
}

.travel-title {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-left: 22px;
}

/* markdown编辑器样式覆盖 */
.info ::v-deep .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.info ::v-deep .v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  height: auto !important;
  z-index: 0 !important;
}

.info ::v-deep .v-note-show .single-show {
  height: auto !important;
}

.info [style*="box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px"] {
  box-shadow: none !important;
  border-top: 1px dashed rgba(255, 255, 255, 0.1) !important;
  border-bottom: none !important;
  border-left: none !important;
  border-right: none !important;
}

.v-note-wrapper {
  border: none;
}

.v-note-panel {
  border: none;
}

/* 时间底部右下角样式 */
.travel-time-footer {
  text-align: right;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 10px;
  font-size: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* ========== 新增全屏预览样式 ========== */
.fullscreen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998 !important;
  cursor: pointer;
  overflow: hidden;
}

.fullscreen-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fullscreen-image {
  z-index: 9999 !important;
  max-width: 80vw !important;
  max-height: 80vh !important;
  width: auto;
  height: auto;
  object-fit: contain;
  cursor: default;
  display: block;
}

/* 移动端适配 */
@media only screen and (max-width: 768px) {
  .content {
    padding-left: 5%;
    padding-right: 5%;
  }
  
  .left {
    width: 100% !important;
  }
  
  .travel-title {
    font-size: 24px;
  }
  
  .province-city {
    font-size: 12px;
  }
}
</style>
